import type { InsurancePolicy } from 'src/interfaces/insurancePolicy'
import type { State } from '../reducers/types'

/**
 * Returns the stored array by reference. Never build a new array or object literal in a
 * selector — every consuming `useSelector` would re-render on each dispatch. Filtering, and
 * deriving the selected policy out of this list, belong in the component under `useMemo`.
 */
export const getInsurancePolicies = (state: State): InsurancePolicy[] => {
  return state.insurancePolicy.policies
}

/**
 * The customer whose policies have SETTLED. The page gates its tables on this rather than on
 * `getInsurancePoliciesLoading`, which is true for every same-customer refetch.
 */
export const getInsurancePoliciesLoadedPartnerId = (state: State): string | null => {
  return state.insurancePolicy.loadedPartnerId
}

export const getInsurancePoliciesLoading = (state: State): boolean => {
  return state.insurancePolicy.loading
}

export const getInsurancePoliciesError = (state: State): string | null => {
  return state.insurancePolicy.error
}

export const getInsurancePolicySaving = (state: State): boolean => {
  return state.insurancePolicy.saving
}

export const getInsurancePolicyDeletingPermanentId = (state: State): string | null => {
  return state.insurancePolicy.deletingPermanentId
}

export const getInsurancePolicyProductDeletingId = (state: State): string | null => {
  return state.insurancePolicy.deletingProductId
}
